<template>
    <div class="label">
        <p v-bind:class="getClass">{{ text }}</p>
    </div>
</template>

<script>
export default {
    name: 'Label',
    props: {
        text: String,
        header: String,
    },
    computed: {
        getClass: function () {
            var vm = this;
            return vm.header;
        }
    }
}
</script>
